import React from "react";
import { useATReportClientColumns } from "./useATReportClientColumns";
import { AccessRights } from "../../../core/navigation/types";
import { TradeList } from "../../../data/trading/trades/types";
import { Table, TableDataProps } from "../../components/common/Table";
import { AnnualTradingReportData } from "../../../data/reports/annualTrade/types";
import { useReportClientData } from "../../../data/reports/annualTrade/hooks/useReportClientData";
import { useAnnualActions } from "./useAnnualActions";

export interface AnnualTradesTableProps {
  userAccessRights: AccessRights;
}

type AnnualTradesTablePropsType = AnnualTradesTableProps &
  TableDataProps<TradeList>;

const ATRClientTable: React.FunctionComponent<AnnualTradesTablePropsType> = ({
  userAccessRights,
  ...tableProps
}) => {
  const columns = useATReportClientColumns();
  const [data, load, reset] = useReportClientData();
  React.useEffect(() => reset, [reset]);

  return (
    <Table<AnnualTradingReportData>
      {...tableProps}
      getData={load}
      immutableData={data}
      title=""
      columns={columns}
      //      actions={actions}
      options={{
        actionsColumnIndex: -1,
        search: false,
        toolbar: false,
      }}
    />
  );
};

export default ATRClientTable;
